require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-polyfill/node_modules/core-js/modules/es7.symbol.async-iterator.js
// module id = 742
// module chunks = 0